import {isNullOrUndefined} from "util";
export class NomModel {
    constructor(public id: any,
                public descripcion: string,
                public descripcionFormularios: string = ''
    ) {

    }
}
